import { render, staticRenderFns } from "./AddProjectDeliverableList.vue?vue&type=template&id=1dcf23c8&"
import script from "./AddProjectDeliverableList.vue?vue&type=script&lang=js&"
export * from "./AddProjectDeliverableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcf23c8')) {
      api.createRecord('1dcf23c8', component.options)
    } else {
      api.reload('1dcf23c8', component.options)
    }
    module.hot.accept("./AddProjectDeliverableList.vue?vue&type=template&id=1dcf23c8&", function () {
      api.rerender('1dcf23c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/AddProjectDeliverableList.vue"
export default component.exports